import axios from "@/axios.js";

export const adminRoleApi = {
  getAdminPermissions(payload) {
    return axios.get("admin-permissions", {
      params: payload,
    });
  },
  getAdminRoles(payload) {
    return axios.get("admin-roles", {
      params: payload,
    });
  },
  getAdminRole(id) {
    return axios.get(`admin-roles/${id}`);
  },
  addAdminRole(body) {
    return axios.post("admin-roles", body);
  },
  updateAdminRole(id, body) {
    return axios.patch(`admin-roles/${id}`, body);
  },
  deleteAdminRole(id) {
    return axios.delete(`admin-roles/${id}`);
  },
};
